import { IExcursionPassenger } from "interfaces/Common/IPassenger";
import { IMusementActivitiesCartType } from "interfaces/Musement/IExcursionCartType";

export const getMusementItemIdsByPersonType = ({
  musementEntries,
  personType,
}: {
  musementEntries: IMusementActivitiesCartType[];
  personType: "Adult" | "Child" | "Baby" | "All";
}) => {
  if (personType === "All") {
    const itemIds = musementEntries?.map(
      (musementEntry: IMusementActivitiesCartType) => musementEntry.id
    );

    return itemIds;
  }

  const itemIds = musementEntries
    .filter((musementEntry: IMusementActivitiesCartType) => {
      const childItem = musementEntry.persons?.find(
        (person: IExcursionPassenger) => person.type === personType
      );

      return childItem; // Keep the entry if there is an adult item
    })
    .map((musementEntry: IMusementActivitiesCartType) => musementEntry.id);

  return itemIds;
};
